import { ClearOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Col, Modal, Row, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import ReactSignatureCanvas from "react-signature-canvas";

interface ModalAssinaturaProps {
  isOpen: boolean;
  handleClose: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  cleanSignature: (signature: ReactSignatureCanvas | null | undefined) => void;
  refAssinante: React.RefObject<ReactSignatureCanvas>;
  nomeAssinante?: string;
}

export function ModalAssinatura({
  isOpen,
  handleClose,
  cleanSignature,
  refAssinante,
  nomeAssinante,
}: ModalAssinaturaProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [canvasWidth, setCanvasWidth] = useState(600); // valor inicial

  useEffect(() => {
    function updateWidth() {
      if (containerRef.current) {
        setCanvasWidth(containerRef.current.offsetWidth);
      }
    }

    if (isOpen) {
      setTimeout(updateWidth, 50);
      window.addEventListener("resize", updateWidth);
    }

    return () => window.removeEventListener("resize", updateWidth);
  }, [isOpen]);

  return (
    <Modal
      title={
        <Typography.Title level={4} style={{ textAlign: "center" }}>
          Assinar no campo abaixo
        </Typography.Title>
      }
      centered
      maskClosable={false}
      open={isOpen}
      width={1400}
      keyboard={true}
      onCancel={handleClose}
      footer={null}
    >
      <Row justify="center" gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} sm={12}>
          <Button
            style={{ width: "100%" }}
            onClick={handleClose}
            icon={<CloseOutlined />}
          >
            Fechar
          </Button>
        </Col>

        <Col xs={24} sm={12}>
          <Button
            style={{ width: "100%" }}
            onClick={(e) => {
              cleanSignature(refAssinante.current);
            }}
            icon={<ClearOutlined />}
          >
            Limpar
          </Button>
        </Col>
      </Row>

      <Row justify="center" style={{ marginTop: 10 }} ref={containerRef}>
        <Col span={24}>
          <ReactSignatureCanvas
            minWidth={2}
            penColor="black"
            ref={refAssinante}
            canvasProps={{
              width: canvasWidth,
              height: 500,
              style: { border: "1px solid #ccc", borderRadius: 8 },
            }}
            clearOnResize={false}
          />
        </Col>

        <Col span={24} style={{ marginTop: 10, textAlign: "center" }}>
          <Typography.Text strong>
            Assinatura {nomeAssinante ? nomeAssinante : "Assinante"}
          </Typography.Text>
        </Col>
      </Row>
    </Modal>
  );
}
